import type { Ref } from 'vue';
import {
  computed,
} from 'vue';

import type { FormSchema } from '@modules/forms/components/VForm/types';
import type { IAdminProfileForm } from '@modules/profile-settings/types';
import { EFormInputTypes } from '@modules/forms/enums';
import { useI18n } from '@modules/i18n/composables';
import { TRANSLATION_GROUP_ADMIN_PROFILE_SETTINGS } from '@modules/profile-settings/constants';
import { useAdminProfileQuery } from '@modules/profile-settings/queries';

export interface AdminGeneralProfileSettingsComposable {
  adminSchema: Ref<FormSchema<IAdminProfileForm>>;
  isLoadingAdminData: Ref<boolean>;
}

export default function useAdminGeneralProfileSettings(): AdminGeneralProfileSettingsComposable {
  const { getTranslation } = useI18n();

  const { data: profile, isLoading: isLoadingAdminData } = useAdminProfileQuery();

  const adminSchema = computed<FormSchema<IAdminProfileForm>>(() => ({
    name: {
      type: EFormInputTypes.TEXT,
      label: getTranslation(TRANSLATION_GROUP_ADMIN_PROFILE_SETTINGS, 'MAIN_NAME').value,
      value: profile.value?.name,
    },
    telegram: {
      type: EFormInputTypes.TEXT,
      label: getTranslation(TRANSLATION_GROUP_ADMIN_PROFILE_SETTINGS, 'MAIN_TELEGRAM').value,
      value: profile.value?.telegram,
    },
    ms_teams: {
      type: EFormInputTypes.TEXT,
      label: getTranslation(TRANSLATION_GROUP_ADMIN_PROFILE_SETTINGS, 'MAIN_MS_TEAMS').value,
      value: profile.value?.ms_teams,
    },
    whatsapp: {
      type: EFormInputTypes.TEXT,
      label: getTranslation(TRANSLATION_GROUP_ADMIN_PROFILE_SETTINGS, 'MAIN_WHATSAPP').value,
      value: profile.value?.whatsapp,
    },
  }));

  return {
    adminSchema,
    isLoadingAdminData,
  };
}
